import { Link, useNavigate } from "react-router-dom";
import { ChevronRight, LogOut } from "lucide-react";
import { MORE_LINKS } from "@/components/Layout";
import { useAuth } from "@/context/Auth";

export default function More() {
  const { user, logout } = useAuth();
  const nav = useNavigate();
  return (
    <div className="max-w-xl space-y-3">
      <h1 className="mb-4 text-2xl font-bold">More</h1>
      {MORE_LINKS.map(([to, label, Icon]) => (
        <Link key={to} to={to} data-testid={`more-link-${to.slice(1)}`} className="cd-card flex items-center gap-3 py-4 hover:border-teal-500">
          <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-teal-50 text-teal-700"><Icon className="h-5 w-5" /></span>
          <span className="flex-1 font-semibold">{label}</span><ChevronRight className="h-4 w-4 text-slate-300" />
        </Link>
      ))}
      <p className="px-1 pt-4 text-xs text-slate-500">Signed in as {user?.email}</p>
      <button data-testid="more-logout-btn" onClick={() => { logout(); nav("/login"); }} className="cd-btn-ghost"><LogOut className="h-4 w-4" />Sign out</button>
    </div>
  );
}
